import styled from 'styled-components';
import Paper from '@mui/material/Paper';

export const Container = styled(Paper)`
  background-color: ${({ theme }) => theme.palette.neutral.offWhite};
  padding: 24px;
`;
